import React, { useContext, useState } from 'react'

import LastInteractionContext from 'common/contexts/last-interaction'

export function LastInteractionContextProvider({ children }) {
  const [lastInteraction, setLastInteraction] = useState(new Date().getTime())

  function registerInteraction() {
    const now = new Date().getTime()

    setLastInteraction(now)
  }

  return (
    <LastInteractionContext.Provider
      value={{
        lastInteraction,
        registerInteraction
      }}
    >
      {children}
    </LastInteractionContext.Provider>
  )
}

export function useLastInteractionContext() {
  return useContext(LastInteractionContext)
}
